import { NavLink } from 'react-router-dom'
import { Menu, Popover } from '@headlessui/react'
import { useAuthUser, useIsAuthenticated } from 'react-auth-kit'
import {
  // UsersIcon,
  UserIcon,
  UserCircleIcon,
  LibraryIcon,
  BookOpenIcon,
  TableIcon,
  AcademicCapIcon,
} from '@heroicons/react/outline'

export default function DashSideNav() {
  const authUser  = useAuthUser()
  const isAuthenticated = useIsAuthenticated()
  const links = isAuthenticated() ? [
    // ...authUser().roles.admin ? [{
    //   name: 'ASMENYS',
    //   description: 'Visų asmenų sąrašas',
    //   to: '/dashboard/people',
    //   icon: UsersIcon,
    // }] : [],
    ...authUser().roles.admin ? [{
      name: 'VARTOTOJAI',
      description: 'Vartotojų sąrašas',
      to: '/dashboard/users',
      icon: UserIcon,
    }] : [],
    {
      name: 'GLOBĖJAI',
      description: 'Visų globėjų sąrašas',
      to: '/dashboard/guardians',
      icon: UserCircleIcon,
    },
    {
      name: 'MOKSLEIVIAI',
      description: 'Visų moksleivių sąrašas',
      to: '/dashboard/students',
      icon: AcademicCapIcon,
    },
    {
      name: 'MOKYTOJAI',
      description: 'Visų mokytojų sąrašas',
      to: '/dashboard/teachers',
      icon: BookOpenIcon,
    },
    {
      name: 'MOKOMIEJI DALYKAI',
      description: 'Visų mokomūjų dalykų sąrašas',
      to: '/dashboard/subjects',
      icon: LibraryIcon,
    },
    ...authUser().roles.admin ? [{
      name: 'KABINETAI',
      description: 'Kabinetų sąrašas',
      to: '/dashboard/classrooms',
      icon: TableIcon,
    }] : [],
    {
      name: 'KLASĖS',
      description: 'Klasių sąrašas',
      to: '/dashboard/classes',
      icon: TableIcon,
    },
    {
      name: 'TVARKARAŠTIS',
      description: 'Tvarkaraščio peržiūra',
      to: '/dashboard/timetable',
      icon: TableIcon,
    },
  ] : []

  return (
    <Popover className='fixed w-full mt-2 shadow-md bg-violet-400 h-[4rem] bottom-0 md:mt-0 md:top-[90px] md:w-60 md:h-full md:bg-white md:px-1 '>
      <Menu as="div" className='flex h-full md:block'>
        <Popover.Group className='flex h-full w-full md:block md:relative justify-between'>
          {links.map((item) => (
            <NavLink
              key={item.name}
              to={item.to}
              className={({isActive}) => isActive
              ? 'flex items-center text-sm py-4 px-6 h-full md:h-12 overflow-hidden text-violet-700 text-ellipsis whitespace-nowrap rounded hover:bg-violet-100 transition duration-300 ease-in-out'
              : 'flex items-center text-sm py-4 px-6 h-full md:h-12 overflow-hidden text-gray-700 text-ellipsis whitespace-nowrap rounded hover:text-gray-900 hover:bg-violet-100 transition duration-300 ease-in-out'}
              >
              <item.icon className="flex-shrink-0 h-6 w-6 text-violet-700" aria-hidden="true" />
              <span className="hidden md:block ml-3 text-base font-medium ">{item.name}</span>
            </NavLink>
          ))}
          {/* <NavLink to='/' className='flex items-center text-sm py-4 px-6 h-12 overflow-hidden text-gray-700 text-ellipsis whitespace-nowrap rounded hover:text-gray-900 hover:bg-gray-100 transition duration-300 ease-in-out" href="#!" data-mdb-ripple="true" data-mdb-ripple-color="dark'>Sidenav link 1</NavLink> */}
        </Popover.Group>
      </Menu>
    </Popover>
  )
}



<NavLink className={({isActive}) => isActive
              ? 'font-bold text-base text-gray-900'
              : 'text-base font-medium text-gray-500 hover:text-gray-900'} to='/dashboard' end>Skydelis</NavLink>



// eslint-disable-next-line no-lone-blocks
{/* <li class="relative" id="sidenavEx1">
          <a class="flex items-center text-sm py-4 px-6 h-12 overflow-hidden text-gray-700 text-ellipsis whitespace-nowrap rounded hover:text-gray-900 hover:bg-gray-100 transition duration-300 ease-in-out cursor-pointer" data-mdb-ripple="true" data-mdb-ripple-color="dark" data-bs-toggle="collapse" data-bs-target="#collapseSidenavEx1" aria-expanded="true" aria-controls="collapseSidenavEx1">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" class="w-3 h-3 mr-3" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path fill="currentColor" d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"></path>
            </svg>
            <span>Click here 1</span>
            <svg aria-hidden="true" focusable="false" data-prefix="fas" class="w-3 h-3 ml-auto" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path>
            </svg>
          </a>
          <ul class="relative accordion-collapse collapse" id="collapseSidenavEx1" aria-labelledby="sidenavEx1" data-bs-parent="#sidenavExample">
            <li class="relative">
              <a href="#!" class="flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-gray-700 text-ellipsis whitespace-nowrap rounded hover:text-gray-900 hover:bg-gray-100 transition duration-300 ease-in-out" data-mdb-ripple="true" data-mdb-ripple-color="dark">Link 1</a>
            </li>
            <li class="relative">
              <a href="#!" class="flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-gray-700 text-ellipsis whitespace-nowrap rounded hover:text-gray-900 hover:bg-gray-100 transition duration-300 ease-in-out" data-mdb-ripple="true" data-mdb-ripple-color="dark">Link 2</a>
            </li>
          </ul>
        </li> */}